import { ChangeDetectorRef, Component, ComponentRef, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { DynamicFormComponent } from "../../../dynamic-form/dynamic-form.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DynamicForm, FormRow } from "../../../../models/dynamic-form";
import { DynamicFormService } from "../../../../services/dynamic-form.service";
import { StatsComponent } from "../../../stats/stats.component";
import { Stats } from "../../../../models/stats.interface";
import { AccordionTableComponent } from "../../../accordion-table/accordion-table.component";
import { ChargeType, DocumentTypeDataListReq, InvoiceType, ViewMode } from "../../../../constants/finance-constants";
import { ActivatedRoute, Router } from "@angular/router";
import DocumentInvoiceConfig from "../config/DocumentInvoice.config.json";
import AdHocChargesTableConfig from "../config/AdHocChargesTableConfig.json";
import adHocChargesTableConfig from "../config/AdHocChargesTableConfig.json";
import MiscellaneousFormConfig from "../config/MiscellaneousForm.config.json";
import DiscountEditableTableConfig from "../config/DiscountsEditableTable.config.json";
import { EditableTableComponent } from "../../../editable-table/editable-table.component";
import { FinanceApiService } from "../../../../services/finance-a-p-iervice.service";
import { APIResponse } from "../../../../models/standard-response.interface";
import { TableHeaderAndData } from "../../../../models/table-header-and-data";
import { Amount, Invoice } from "../../../../models/invoice.interface";
import { LoadingService } from "../../../../services/loading.service";
import { ToasterService } from "../../../../services/toaster.service";
import { EditableTableHeader } from "../../../../models/editable-table-header.interface";
import { Charge } from "../../../../models/charge.interface";
import { StaticTableComponent } from "../../../static-table/static-table.component";
import { RightPanelComponent } from "../../../right-panel/right-panel.component";
import ChargeTableMetaConfig from "../config/ChargeTableMeta.config.json";
import { TableMeta } from "../../../../models/table-meta.interface";
import { HorizontalTabsComponent } from "../../../horizontal-tabs/horizontal-tabs.component";
import { MultiSelectComponent } from "../../../select/multi-select.component";
import { AutocompleteDropdownComponent } from "../../../autocomplete-dropdown/autocomplete-dropdown.component";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { NgClass, NgIf } from "@angular/common";
import { MatAccordion } from "@angular/material/expansion";
import { AccordionData, TosAccordionComponent } from "../../../tos-accordion/tos-accordion.component";
import { DateUtils } from "../../../../utils/date-utils";
import { forkJoin, of } from "rxjs";
import { ChargeCalculationRequest } from "../../../../models/charge-calculation-request";
import { catchError } from "rxjs/operators";
import { TosTableService } from "../../../../services/tos-table.service";
import { CommonUtils } from "../../../../utils/common-utils";
import { ToggleComponent } from "../../../common/toggle/toggle.component";
import { ModalComponent } from "../../../modal/modal.component";
import { PageCloseButtonComponent } from "../../../common/close-button/page-close-button.component";
import { ContactInformation } from "../../../../models/masters/contact-information.interface";
import { TariffOverviewComponent } from "../tariff-overview/tariff-overview.component";
import { TariffCalculatedResponse } from "../../../../models/tariff-rule-set";
import { CustomerService } from "../../../../services/masters/customer-service";

interface GstSettings{
  gstApplicable: boolean;
  gstPercentage: number;
}

@Component({
  selector: "app-manage-invoices",
  standalone: true,
  imports: [
    DynamicFormComponent,
    StatsComponent,
    AccordionTableComponent,
    EditableTableComponent,
    ReactiveFormsModule,
    StaticTableComponent,
    HorizontalTabsComponent,
    MultiSelectComponent,
    AutocompleteDropdownComponent,
    SvgIconComponent,
    NgClass,
    NgIf,
    TosAccordionComponent,
    TosAccordionComponent,
    ToggleComponent,
    PageCloseButtonComponent
  ],
  templateUrl: "./manage-invoices.component.html",
  styleUrl: "./manage-invoices.component.scss"
})

export class ManageInvoicesComponent {
  private _showInvoiceContent: boolean = false;
  private _readOnlyMode: boolean = false;

  customerIdVsContactInfoMap: Map<string, Array<ContactInformation>> = new Map<string, Array<ContactInformation>>();
  editingEnabled: boolean = false;
  invoiceFrom: FormGroup;
  dynamicFormConfig!: DynamicForm;
  documentStats: Stats[] = [];
  invoiceType!: InvoiceType;
  //TODO: Move to config file
  accordionTableData: TableHeaderAndData = DocumentInvoiceConfig.accordionTableData;
  showDocumentStats: boolean = false;
  adHocChargesTableConfig: EditableTableHeader[] = AdHocChargesTableConfig.containerLevel;
  discountTableConfig: EditableTableHeader[] = DiscountEditableTableConfig.invoiceLevel;
  adHocChargesContainerTableData: any[] = [];
  adHocChargesInvoiceTableData: any[] = [];
  discountContainerTableData: any | undefined = [];
  discountInvoiceTableData: any[] = this.adHocChargesInvoiceTableData;
  documentAmountInfo: Amount = this.initializeDocumentAmountInfo();
  containerIdChargeMap: Map<string, any> = new Map<string, any>();
  chargeTableConfig: TableMeta = ChargeTableMetaConfig;
  containerNumberSelectOptions: { label: any, value: any }[] = [];
  addAdHocChargesForm: FormGroup | undefined;
  expandedRowIndex: number = -1;
  adHocChargeTabs: { id: string; label: string }[] = [{
    id: "containerCharge",
    label: "Container Charge"
  }, {
    id: "invoiceCharge",
    label: "Invoice Charge"
  }];
  discountTabs: { id: string; label: string }[] = [{
    id: "containerDiscounts",
    label: "Container Discounts"
  }, {
    id: "invoiceDiscounts",
    label: "Invoice Discounts"
  }];
  adHocChargeSelectedTab: string = this.adHocChargeTabs[0].id;
  discountSelectedTab: string = this.discountTabs[0].id;
  invoiceAdHocChargesData: any[] = [];
  invoiceId: string = "";
  gstSettingsForm: FormGroup | undefined;
  gstChangeConfirmModalComponentRef!: ComponentRef<any>
  gstSettingRightPanelComponentRef!: ComponentRef<any>
  gstSetting: GstSettings = {
    gstApplicable: true,
    gstPercentage: 18
  }

  protected readonly InvoiceType = InvoiceType;

  @ViewChild("accordionTableComponent") accordionTableComponent!: AccordionTableComponent;
  @ViewChild("addChargesTable") addChargeTableTemplate!: TemplateRef<any>;
  @ViewChild("chargesViewTable") chargesViewTable!: TemplateRef<any>;
  @ViewChild("discountsAccordion") discountsAccordion!: TemplateRef<MatAccordion>;
  @ViewChild("tosAccordion") tosAccordion!: TosAccordionComponent;
  @ViewChild("gstSettingsTemplate") gstSettingTemplate!: TemplateRef<any>;
  @ViewChild("gstSettingConfirmModal") gstSettingConfirmModal!: TemplateRef<any>;


  constructor(private fb: FormBuilder,
              private dynamicFormService: DynamicFormService,
              private route: ActivatedRoute,
              private financeService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private router: Router,
              private cdr: ChangeDetectorRef,
              private viewContainerRef: ViewContainerRef,
              private tosTableService: TosTableService,
              private customerService: CustomerService
            ) {
    this.invoiceFrom = this.fb.group({});
    this.gstSettingsForm = this.fb.group({
      gstApplicable: [true, Validators.required],
      gstPercentage: [18, Validators.required],
    });
  }

  ngOnInit() {
    this.initializeComponent();
  }


  protected handleInlineActions(data: any) {

    this.loadTariffOverview(data?.record);
  }

  get showInvoiceContent(): boolean {
    return this._showInvoiceContent;
  }

  set showInvoiceContent(value: boolean) {
    if(value){
      this.gstSettingsForm?.disable()
    }
    this._showInvoiceContent = value;
  }

  get readOnlyMode(): boolean {
    return this._readOnlyMode;
  }

  set readOnlyMode(value: boolean) {
    if(value)
      this.initializeComponentForViewOnlyMode();
    this._readOnlyMode = value;
  }

  reset(): void {
    const currentUrl = this.router.url;

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }

  goBack() {
    const viewingMode = this.route.snapshot.queryParamMap.get("view");
    if (viewingMode === ViewMode.CARD) {
      this.router.navigateByUrl(`/manage-finance/invoices/details`);
    } else
      this.router.navigateByUrl(`/manage-finance/invoices`);
  }

  saveInvoices() {
    this.invoiceFrom.markAllAsTouched();
    if (this.invoiceFrom.invalid) {
      return;
    }
    const invoiceGenerationRequest = this.prepareInvoiceGenerationRequest();
    console.log(invoiceGenerationRequest);

    this.callApiToSaveInvoice(invoiceGenerationRequest);
  }

  handleSuggestionSelected(selectedItem: { controlName: string, result: any }) {
    if (selectedItem.controlName === "documentType") {
      this.updateLookupDetailsForDocumentNumberField(selectedItem.result.value);
    }

    if (selectedItem.controlName === "documentNumber") {
      this.getItemsDetails();
    }

    if (selectedItem.controlName === "customerId") {
      //this.populateContactInformation(selectedItem);
    }

    if (selectedItem.controlName === "billingPartyId") {
      this.populateContactInformation(selectedItem);
    }

    if (selectedItem.controlName === "payingPartyId") {
    }

    if (selectedItem.controlName === "paymentTerm") {
      console.log(this.invoiceFrom.get("paymentTerm")?.value);
    }
  }

  getInvoiceEstimate() {
    this.invoiceFrom.markAllAsTouched();
    if (this.invoiceFrom.invalid) {
      return;
    }

    const invoiceGenerationRequest: Invoice = this.prepareInvoiceGenerationRequest();

    console.log(invoiceGenerationRequest);
    this.callApiToGenEstimates(invoiceGenerationRequest);
  }

  loadItemAccordionContent(data: { rowId?: string, rowIndex: number, rowData: any }) {
    let chargeInfo: any = this.containerIdChargeMap.get(data.rowData?.itemDetails?.containerId ?? data.rowData?.containerId);
    chargeInfo = chargeInfo.map((charge: any) => {
      const chargeType = ChargeType[charge.type as keyof typeof ChargeType];
      return {
        ...charge,
        description: chargeType === ChargeType.ADHOC ? `${charge.description} (Ad-Hoc)` : charge.description,
        discountPercentage: ((charge.discount / charge.amount) * 100).toFixed(2)
      };
    });


    if (this.accordionTableComponent && data.rowIndex >= 0)
      this.accordionTableComponent.loadComponent(this.chargesViewTable, data.rowIndex, { tableData: chargeInfo });
  }

  //AD-HOC Charges
  addAdHocCharges() {
    // this.adHocChargesTableData.push({});
    this.setupRightPanelForCharges();
  }

  handleAdHocChargeDataDeletion(data: any) {
    const tableData = this.adHocChargeSelectedTab === this.adHocChargeTabs[0].id ? this.adHocChargesContainerTableData : this.adHocChargesInvoiceTableData;
    tableData.splice(data.rowIndex, 1);
  }

  addChargesForContainerFormOnSubmit() {
    if (!this.addAdHocChargesForm?.valid) {
      return;
    }
    console.log(this.addAdHocChargesForm.value);
    this.loadingService.show();

    const sameChargeExistsForContainer = this.adHocChargesContainerTableData.filter((data) =>
      data.chargeId === this.addAdHocChargesForm?.value.charge.key &&
      data.containerId === this.addAdHocChargesForm?.value.container.value).length > 0;
    if (sameChargeExistsForContainer) {
      this.loadingService.hide();
      this.toasterService.error("Charge already exists for selected container");
      return;
    }

    const chargeCalculationRequest: ChargeCalculationRequest = {
      ...this.gstSetting,
      itemId: this.invoiceFrom.get("documentNumber")?.value.key,
      billingAddressId: this.invoiceFrom.get("billingAddressId")?.value,
      containerId: this.addAdHocChargesForm.value.container.value,
      chargeId: this.addAdHocChargesForm.value.charge.key,
      validTill: this.invoiceFrom.get("validTill")?.value,
      customerId: this.invoiceFrom.get("customerId")?.value.value,
      billingPartyId: this.invoiceFrom.get("billingPartyId")?.value.key
    };

    const estimate$ = this.financeService.getEstimateForCharge(chargeCalculationRequest).pipe(
      catchError((error) => {
        console.error("Estimate API failed:", error);
        return of({ data: { amount: 0 } });
      })
    );
    const charges$ = this.financeService.getChargesById(this.addAdHocChargesForm.value.charge.key);

    forkJoin([estimate$, charges$]).subscribe({
      next: ([estimateResponse, chargeResponse]) => {
        this.loadingService.hide();

        const chargeDetails: Charge = chargeResponse.data;
        const chargeData = {
          chargeName: chargeDetails.name,
          chargeCode: chargeDetails.code,
          hsnOrSacCode: chargeDetails.hsnOrSacCode
        };

        this.adHocChargesContainerTableData.push({
          ...chargeData,
          chargeId: chargeDetails.id,
          amount: estimateResponse.data.amount,
          containerId: this.addAdHocChargesForm?.value.container.value,
          containerNumber: this.addAdHocChargesForm?.value.container.label
        });

        this.addAdHocChargesForm?.reset();
        console.log(this.adHocChargesContainerTableData);
      },
      error: (error: any) => {
        this.loadingService.hide();
        this.toasterService.error(error.error.message);
      }
    });
  }

  handleAdHocChargeTabSelection(tabId: any) {
    this.adHocChargeSelectedTab = tabId;
    this.adHocChargesTableConfig = this.adHocChargeSelectedTab === this.adHocChargeTabs[0].id ? AdHocChargesTableConfig.containerLevel : AdHocChargesTableConfig.invoiceLevel;
    this.addAdHocChargesForm = this.adHocChargeTabs[0].id === this.adHocChargeSelectedTab ? this.fb.group({
        container: [null, Validators.required],
        charge: [null, Validators.required]
      }) :
      this.fb.group({
        charge: [null, Validators.required]
      });
  }

  addAdHocChargesForInvoice() {
    const chargeId = this.addAdHocChargesForm?.get("charge")?.value?.key;

    if (!chargeId) return;

    this.loadingService.show();
    this.financeService.getChargesById(chargeId).subscribe({
      next: (res) => {
        const chargeDetails: Charge = res.data;
        this.adHocChargesInvoiceTableData.push({
          ...chargeDetails,
          chargeName: chargeDetails.name,
          chargeId: chargeDetails.id,
          chargeCode: chargeDetails.code
        });
        this.addAdHocChargesForm?.reset();
        this.loadingService.hide();
      },
      error: (error: any) => {
        this.loadingService.hide();
      }
    });
  }

  //Discounts
  handleDiscountsTabSelection(tabId: any) {
    this.discountSelectedTab = tabId;
    this.discountTableConfig = this.discountSelectedTab === this.discountTabs[0].id ? DiscountEditableTableConfig.containerLevel : DiscountEditableTableConfig.invoiceLevel;
    // this.discountInvoiceTableData = [...this.adHocChargesInvoiceTableData] || [];
  }

  addDiscounts() {
    this.setUpRightPanelForDiscount();
  }

  handleDiscountAccordionOpened(event: { index: number, rowData: any }) {
    this.discountContainerTableData = this.containerIdChargeMap.get(event.rowData?.data?.containerId);
    this.tosAccordion.loadComponent(EditableTableComponent, event.index, {
      tableHeaders: this.discountTableConfig,
      tableData: this.discountContainerTableData,
      showSearchBarWithSuggestions: false,
      showInputFieldsOnTh: false,
    });
  }

  getDiscountTableData(): AccordionData[] {
    return this.accordionTableData.data.map((data) => {
      return { title: data.containerNo, data };
    });
  }

  private initializeComponent() {
    this.setInvoiceType();
    if (this.invoiceType === InvoiceType.MISCELLANEOUS) {
      this.adHocChargeTabs = this.adHocChargeTabs.filter(tab => tab.id !== "containerCharge");
      this.discountTabs = this.discountTabs.filter(tab => tab.id !== "containerDiscounts");
      this.adHocChargeSelectedTab = this.adHocChargeTabs[0]?.id;
      this.discountSelectedTab = this.discountTabs[0]?.id;
    }

    this.addAdHocChargesForm = this.adHocChargeSelectedTab === "containerCharge" ? this.fb.group({
        container: [null, Validators.required],
        charge: [null, Validators.required]
      }) :
      this.fb.group({
        charge: [null, Validators.required]
      });

    this.dynamicFormService.addControlsToForm(this.invoiceFrom, this.dynamicFormConfig);
    this.dynamicFormService.addControlToFormGroup(this.invoiceFrom, "customerNotes");
    this.dynamicFormService.addControlToFormGroup(this.invoiceFrom, "tallyNotes");

    this.readOnlyMode = this.route.snapshot.url[0].path === "view";
  }

  private initializeComponentForViewOnlyMode() {
    this.invoiceId = this.route.snapshot.paramMap.get("invoiceId") || "";
    // this.makeInvoiceFormReadOnly(true)
    this.invoiceFrom.disable()
    this.removeConditionsFromFormConfig();


    // Filter out documentType and documentNumber fields in view mode
    this.dynamicFormConfig.formRows.forEach((row: FormRow) => {
      row.formGroups = row.formGroups.filter(group => {
        const controlLabel = group.control.label;
        return controlLabel !== "documentType" && controlLabel !== "chargeGroupId";
      });
    });

    this.dynamicFormService.addControlsToForm(this.invoiceFrom, this.dynamicFormConfig);

    this.callApiToGetInvoiceDetails(this.invoiceId);
  }

  private setInvoiceType() {
    const invoiceTypeParam = this.route.snapshot.queryParamMap.get("type");
    if (!invoiceTypeParam || !Object.values(InvoiceType).includes(invoiceTypeParam as InvoiceType)) {
      console.error("Invalid invoice type");
      this.invoiceType = InvoiceType.MISCELLANEOUS; //reset to miscellaneous
    }

    this.invoiceType = invoiceTypeParam as InvoiceType;
    //TODO: Get this from config map
    this.dynamicFormConfig = this.invoiceType === InvoiceType.DOCUMENT
      ? CommonUtils.deepCopyJson(DocumentInvoiceConfig)
      : CommonUtils.deepCopyJson(MiscellaneousFormConfig);
  }

  private prepareInvoiceGenerationRequest() {
    const items = [
      ...this.adHocChargesContainerTableData.map((data: any) => ({
        ...data,
        amount: {
          amount: data.amount,
          discount: this.getDiscountForAdHocCharge(data)
        }
      })),
      ...this.adHocChargesInvoiceTableData.map((data: any) => ({
        ...data,
        amount: {
          amount: data.amount,
          discount: data.discount,
        }
      }))
    ];

    const containerDiscounts = Array.from(this.containerIdChargeMap.entries()).flatMap(([containerId, charges]) => {
      return charges
        .filter((charge: any) => charge.discount > 0 && ChargeType[charge.type as keyof typeof ChargeType] === ChargeType.SYSTEM)
        .map((charge: any) => ({
          id: charge.id,
          discount: charge.discount
        }));
    });

    const discounts = [...containerDiscounts];

    const invoiceGenerationRequest: Invoice = {
      ...this.invoiceFrom.value,
      ...this.gstSetting,
      documentType: this.invoiceFrom.get("documentType")?.value,
      itemId: this.invoiceFrom.get("documentNumber")?.value.key,
      chargeGroupId: this.invoiceFrom.get("chargeGroupId")?.value.key,
      customerId: this.invoiceFrom.get("customerId")?.value.key ?? this.invoiceFrom.get("customerId")?.value.value,
      billingPartyId: this.invoiceFrom.get("billingPartyId")?.value.key,
      invoiceType: this.invoiceType === InvoiceType.DOCUMENT ? "IMP" : "OTH",
      items,
      discounts,

    };
    return invoiceGenerationRequest;
  }

  private getDiscountForAdHocCharge(data: any): number {
    const discountSource = data.containerId ? this.containerIdChargeMap.get(data.containerId) : this.discountInvoiceTableData;

    return discountSource.find((discount: any) =>
      discount.chargeId === data.chargeId &&
      ChargeType[discount.type as keyof typeof ChargeType] === ChargeType.ADHOC &&
      (!data.containerId || discount.containerId === data.containerId)
    )?.discount || 0;
  }

  private updateLookupDetailsForDocumentNumberField(documentType: keyof typeof DocumentTypeDataListReq) {
    for (const row of this.dynamicFormConfig.formRows) {
      for (const group of row.formGroups) {
        if (group.control.label === "documentNumber" && group.control.fieldInfo) {
          if (!DocumentTypeDataListReq[documentType]) {
            group.control.fieldInfo.lookupDetails = undefined;
            return;
          }
          group.control.fieldInfo.lookupDetails = DocumentTypeDataListReq[documentType].lookupDetails;
        }
      }
    }
    this.dynamicFormService.addControlsToForm(this.invoiceFrom, this.dynamicFormConfig, false);
  }

  private callApiToGenEstimates(invoiceGenerationRequest: Invoice, rightPanelComponentRef?: ComponentRef<RightPanelComponent>) {
    this.loadingService.show();
    this.financeService.estimateInvoice(invoiceGenerationRequest).subscribe({
      next: (res: APIResponse) => {
        this.processAndSetAccordionTableData(res.data.containerInvoiceItems);
        this.processAndSetInvoiceAdHocCharges(res.data.items);
        this.setContainerNoForAdHocChargeTable(res);
        this.documentAmountInfo = res.data.amount;
        this.showInvoiceContent = true;
        // this.invoiceFrom.disable()
        // this.makeInvoiceFormReadOnly(true);
        rightPanelComponentRef?.destroy();
        this.loadingService.hide();
      },
      error: (error: any) => {
        this.toasterService.error(error.error.errorDesc);
        this.loadingService.hide();
      }
    });

  }

  private setContainerNoForAdHocChargeTable(res: APIResponse): void {
    if (!res?.data?.containerInvoiceItems?.length) return;

    this.containerNumberSelectOptions = res.data.containerInvoiceItems.map((item: {
      containerNo: string;
      containerId: number
    }) => ({
      label: item.containerNo,
      value: item.containerId
    }));
  }

  private processAndSetAccordionTableData(containerInvoiceItems: any) {
    this.accordionTableData.data = containerInvoiceItems.map((item: any) => {
      const itemCharges = this.destructureCharges(item.charges);
      this.containerIdChargeMap.set(item.containerId, itemCharges);
      this.loadItemAccordionContent({ rowIndex: this.expandedRowIndex, rowData: { itemDetails: item } });
      return {
        ...item.metadata,
        ...item.amount,
        gateInDate: DateUtils.formatDate(item.metadata?.gateInDate, "dd/MM/yyyy"),
        gateOutDate: DateUtils.formatDate(item.metadata?.gateOutDate, "dd/MM/yyyy")
      };
    });
  }

  private destructureCharges(charges: any) {
    return charges.map((charge: any) => ({
      ...charge,
      ...charge.amount,
      ...charge.metadata
    }));
  }

  private getItemsDetails() {
    const documentType = this.invoiceFrom.get("documentType")?.value;

    const formDocumentNumber = this.invoiceFrom.get("documentNumber")?.value;
    const documentId = documentType === DocumentTypeDataListReq.CONTAINER_NUMBER.key ? formDocumentNumber.key : formDocumentNumber.value;

    if (!documentType || !documentId) return;

    this.callApiToFetchItemDetails(documentType, documentId);
  }

  private callApiToFetchItemDetails(documentType: any, documentId: any) {
    this.loadingService.show();
    const dto: { documentType: string, documentId: string } = { documentType, documentId };
    this.financeService.fetchItemDetails(dto).subscribe({
      next: (res: APIResponse) => {
        this.populateCustomerFieldOptions(res?.data?.customers);
        this.populateItemInfoStats(res?.data);
        this.customerIdVsContactInfoMap = new Map(res?.data?.customers.map((customer: any) => [customer.id, customer.contactInformation]));
        this.loadingService.hide();
      },
      error: (error: any) => {
        this.loadingService.hide();
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  private populateCustomerFieldOptions(customers: any[]) {
    for (const row of this.dynamicFormConfig.formRows) {
      for (const group of row.formGroups) {
        if (group.control.label === "customerId" && group.control.fieldInfo) {
          group.control.fieldInfo.options = customers.map((customer: any) => {
            return {
              label: customer.name,
              value: customer.id
            };
          });
        }
      }
    }
    this.dynamicFormService.addControlsToForm(this.invoiceFrom, this.dynamicFormConfig, false);
  }

  async populateContactInformation(selectedCustomer: any) {
    const customer = selectedCustomer.result;
    const contactInfo = await this.customerService.getCustomerContacts(customer.id);
    for (const row of this.dynamicFormConfig.formRows) {
      for (const group of row.formGroups) {
        if (group.control.label === "billingAddressId" && group.control.fieldInfo) {
          group.control.fieldInfo.options = contactInfo?.map((contact: ContactInformation) => {
            return {
              label: contact.address,
              value: contact.id
            };
          });
        }
      }
    }
    this.dynamicFormService.addControlsToForm(this.invoiceFrom, this.dynamicFormConfig, false);
  }



  private callApiToSaveInvoice(invoiceGenerationRequest: Invoice) {
    this.loadingService.show();
    this.financeService.generateInvoice(invoiceGenerationRequest).subscribe({
      next: (res: APIResponse) => {
        console.log(res);
        this.goBack();
        this.loadingService.hide();
        this.toasterService.success("Successfully generated invoice");
      },
      error: (error: any) => {
        this.loadingService.hide();
        this.toasterService.error(error.error.message);
      }
    });
  }

  private setupRightPanelForCharges() {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Add-hoc Charges";
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.loadComponent(this.addChargeTableTemplate, {
        tableHeaders: adHocChargesTableConfig,
        tableData: this.adHocChargesContainerTableData,
        showSearchBarWithSuggestions: false,
        showActionButtons: false
      }
    );
    rightPanelComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      const invoiceGenerationRequest = this.prepareInvoiceGenerationRequest();
      this.callApiToGenEstimates(invoiceGenerationRequest, rightPanelComponentRef);
    });

    rightPanelComponentRef.instance.close.subscribe(() => {
      rightPanelComponentRef.destroy();
    });
  }

  private processAndSetInvoiceAdHocCharges(items: any[]) {
    this.invoiceAdHocChargesData = items.map((item: any) => {
      return {
        ...item,
        chargeCode: item?.metadata?.chargeCode,
        amount: item.amount.amount,
        igst: item.amount.igst,
        cgst: item.amount.cgst,
        sgst: item.amount.sgst,
        discount: item.amount.discount,
        discountPercentage: (item.amount.discount / item.amount.amount) * 100,
        totalAmount: item.amount.totalAmount
      };
    });
  }

  private makeInvoiceFormReadOnly(value: boolean) {
    this.dynamicFormConfig?.formRows?.forEach((formRow: any) => {
      formRow.formGroups?.forEach((formGroup: any) => {
        formGroup.control.isReadOnly = value;
      });
    });
  }

  private setUpRightPanelForDiscount() {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Discounts";
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.loadComponent(this.discountsAccordion);
    rightPanelComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      const invoiceGenerationRequest = this.prepareInvoiceGenerationRequest();
      this.callApiToGenEstimates(invoiceGenerationRequest);
      rightPanelComponentRef.destroy();
    });

    rightPanelComponentRef.instance.close.subscribe(() => {
      rightPanelComponentRef.destroy();
    });
  }

  private populateItemInfoStats(res: any) {
    if(res.invoiceType === "OTH" ) return

    const documentInfo = res.document ?? res
    this.documentStats = [{ displayLabel: "Document No.", value: documentInfo.igmItemNo }];

    this.documentStats = [
      ...this.documentStats,
      ...Object.entries(res?.documentDetails || {}).map(([key, value]) => ({
        displayLabel: key,
        value: value as string
      }))
    ];

    this.showDocumentStats = true;
  }

  private initializeDocumentAmountInfo() {
    return { amount: 0, igst: 0, sgst: 0, cgst: 0, totalAmount: 0, discount: 0 };
  }

  private callApiToGetInvoiceDetails(invoiceId: string) {
    this.loadingService.show();
    this.financeService.getInvoiceDetails(invoiceId).subscribe({
      next: (res: any) => {
        const invoiceInputData = res?.data;
        this.populateItemInfoStats(invoiceInputData)

        this.populateSelectFieldOptions(invoiceInputData).then(r => {
          this.invoiceFrom.patchValue({
            ...invoiceInputData,
            documentNumber: invoiceInputData.document.igmItemNo,
            validTill: invoiceInputData.dueDate,
            customerId: { label: invoiceInputData?.customer?.name, value: invoiceInputData?.customer?.id },
            billingPartyId: { value: invoiceInputData?.billingParty?.name, key: invoiceInputData?.billingParty?.id },
            billingAddressId: {
              label: invoiceInputData?.billingParty?.address?.addressLine1,
              value: invoiceInputData?.billingParty?.address?.addressLine1
            }
          });
        });
        this.showInvoiceContent = true;
        this.documentAmountInfo = invoiceInputData?.amount;
        this.processAndSetAccordionTableData(invoiceInputData?.containerInvoiceItems);
        this.processAndSetInvoiceAdHocCharges(invoiceInputData?.items);
        this.loadingService.hide();
      },
      error: (err: any) => {
        this.toasterService.error(err.error.message);
        this.loadingService.hide();
      }
    });
  }

  private removeConditionsFromFormConfig() {
    this.dynamicFormConfig.formRows.forEach((row: FormRow) => {
      row.formGroups.forEach((group) => {
        if (group.control?.conditions) {
          group.control.conditions = {};
        }
      });
    });
  }

  private populateSelectFieldOptions(invoiceInputData: any) {

    return new Promise<void>(resolve => {
      const customer = this.dynamicFormConfig.formRows.flatMap((row: FormRow) => row.formGroups).find((formGroup) => formGroup.control.label === "customerId");
      const billingAddress = this.dynamicFormConfig.formRows.flatMap((row: FormRow) => row.formGroups).find((formGroup: any) => formGroup.control.label === "billingAddress");

      if (customer?.control.fieldInfo?.options) {
        customer.control.fieldInfo.options = [{
          label: invoiceInputData?.customer?.name,
          value: invoiceInputData?.customer?.id
        }];
        resolve();
      }

      if (billingAddress?.control.fieldInfo?.options) {
        billingAddress.control.fieldInfo.options = [{
          label: invoiceInputData?.billingParty?.address,
          value: invoiceInputData?.billingParty?.address
        }];
        resolve();
      }
    });

  }

  overrideGstSettings() {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);

    this.gstSettingRightPanelComponentRef = rightPanelComponentRef;

    rightPanelComponentRef.instance.title = "GST Settings";
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.loadComponent(this.gstSettingTemplate);
    rightPanelComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      if(!this.showInvoiceContent) {
        this.submitGstSettingForm();
      }else {
        this.toasterService.warning("Please reset the invoice to change GST settings");
      }
    });

    rightPanelComponentRef.instance.close.subscribe(() => {
      rightPanelComponentRef.destroy();
    });
  }

  private submitGstSettingForm() {
    this.gstSettingsForm?.markAllAsTouched();
    if(!this.gstSettingsForm?.valid){
      return
    }

    this.gstChangeConfirmModalComponentRef = this.viewContainerRef.createComponent(ModalComponent);

    const gstChangeConfirmModalComponentRef = this.gstChangeConfirmModalComponentRef
    gstChangeConfirmModalComponentRef.instance.title = "GST Settings";
    gstChangeConfirmModalComponentRef.instance.loadComponent(this.gstSettingConfirmModal);
    gstChangeConfirmModalComponentRef.instance.close.subscribe(() => {
      gstChangeConfirmModalComponentRef.destroy()
    })
  }

  onGstToggleChange(isGstApplicable: boolean): void {
    const gstPercentage = this.gstSettingsForm?.get('gstPercentage');
    if (isGstApplicable) {
      gstPercentage?.enable();
    } else {
      gstPercentage?.disable();
    }
  }

  setGstSettingsState() {
    this.gstSetting = {
      gstApplicable: this.gstSettingsForm?.get('gstApplicable')?.value,
      gstPercentage: this.gstSettingsForm?.get('gstPercentage')?.value
    }
    this.gstChangeConfirmModalComponentRef.destroy();
    this.gstSettingRightPanelComponentRef.destroy();
  }

  private loadTariffOverview(record: any) {
    const tariffCalculatedResponse: TariffCalculatedResponse = record?.tariffCalculateResponse;
    const chargeName: string = record?.chargeName;


    if(!CommonUtils.isNotNil(tariffCalculatedResponse?.tariffId)) {
      this.toasterService.warning("Tariff ID is empty");
      return;
    }

    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Tariff Overview";
    const tariffOverviewCompRef: ComponentRef<TariffOverviewComponent> = rightPanelComponentRef.instance.loadComponent(TariffOverviewComponent);
    Object.assign(tariffOverviewCompRef.instance,{
      tariffCalculatedResponse,
      chargeName
    })
    rightPanelComponentRef.instance.close.subscribe(() => {
      rightPanelComponentRef.destroy();
    })
  }
}

